import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

interface SectionMarkdownProps {
  title?: string;
  body: string;
}

export function SectionMarkdown({ body }: SectionMarkdownProps) {
  return (
    <div className="prose prose-invert max-w-none px-5 py-4 text-sm text-foreground/90 [&_table]:block [&_table]:overflow-x-auto">
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{body}</ReactMarkdown>
    </div>
  );
}
